import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";

export const DEFAULT_SETTINGS = {
  hero_image: "/images/libre.jpg",
  hero_caption: "Je suis libre",
  marquee: ["Aquarelle", "Acrylique", "Collage", "Filets d'or", "Pièces uniques", "Créées au Québec", "Monde marin", "Cœurs"],
  categories: [
    { key: "marin", label: "Collection Monde marin" }, { key: "faune", label: "Collection Faune" },
    { key: "coeur", label: "Collection Cœurs" }, { key: "autre", label: "Autres produits" },
  ],
};

const Ctx = createContext({ settings: DEFAULT_SETTINGS, setSettings: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    api.get("/settings").then((r) => {
      const d = r.data || {};
      setSettings({
        ...DEFAULT_SETTINGS, ...d,
        marquee: Array.isArray(d.marquee) && d.marquee.length ? d.marquee : DEFAULT_SETTINGS.marquee,
        categories: Array.isArray(d.categories) && d.categories.length ? d.categories : DEFAULT_SETTINGS.categories,
      });
    }).catch(() => {});
  }, []);
  return <Ctx.Provider value={{ settings, setSettings }}>{children}</Ctx.Provider>;
};

export const useSettings = () => useContext(Ctx);

export const useCats = () => {
  const { settings } = useSettings();
  return useMemo(() => Object.fromEntries(settings.categories.map((c) => [c.key, c.label])), [settings.categories]);
};
